import { useState, useEffect } from 'react';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Select, Options } from '../../components/Select';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Button, Col, Row, Pagination, Modal } from 'react-bootstrap';
import Search from '../../components/Search';
import { Table, TBody, TCell, TGroup, THeader, TRow, ThCell } from '../../components/Table/Table';
import { FillPlus } from '../../components/Icons';
import { Title } from '../../components/Title';
import './style.css';
import AlertMessage from '../../components/Alert';

export function Credenciados() {
    const [isLoading, setIsLoading] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [accredited, setAccredited] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [employeesPerPage, setEmployeesPerPage] = useState(20);
    const [employeesPerPageOptions] = useState([5, 10, 15, 20, 50, 100]);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentFilteredEmployees, setCurrentFilteredEmployees] = useState([]);
    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [chavePix, setChavePix] = useState('');
    const [documento, setDocumento] = useState("");
    const [porcentagem, setPorcentagem] = useState(0);

    // Calcula o índice do primeiro e do último funcionário na página atual
    const indexOfLastEmployee = currentPage * employeesPerPage;
    const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;

    const currentEmployees = accredited.slice(indexOfFirstEmployee, indexOfLastEmployee);

    const filteredEmployees = accredited.filter((employee: any) => {
        return (
            employee.nome.toLowerCase().includes(searchQuery.toLowerCase()) ||
            employee.id.toString().includes(searchQuery)
        );
    });

    const [show, setShow] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [idSelected, setIdSelected] = useState('');

    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });

    const handleClose = () => setShow(false);

    const handleCloseEditModal = () => setShowEditModal(false);

    const showModal = (id: any) => {
        console.log('teste')
        setIdSelected(id)
        setShow(true)
    }

    useEffect(() => {
        const indexOfLastFilteredEmployee = currentPage * employeesPerPage;
        const indexOfFirstFilteredEmployee = indexOfLastFilteredEmployee - employeesPerPage;
        const newCurrentFilteredEmployees = filteredEmployees.slice(indexOfFirstFilteredEmployee, indexOfLastFilteredEmployee);

        setCurrentFilteredEmployees(newCurrentFilteredEmployees);
    }, [currentPage, employeesPerPage, filteredEmployees]);

    const loadAccredited = async () => {
        try {
            const response = await api.get('listar-credenciados');
            setAccredited(response.data);
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    };

    const handleEmployeesPerPageChange = (value: any) => {
        setEmployeesPerPage(Number(value));
        setCurrentPage(1); // Volta para a primeira página ao mudar a quantidade por página
    };

    useEffect(() => {
        loadAccredited();
    }, []);

    const handleSelectCompany = (id: any) => {
        setSelectedCompany(id);
    };

    const handleSearchChange = (value: string) => {
        setSearchQuery(value);
        setCurrentPage(1);
    };

    /*paginação*/
    const paginationItems = () => {
        let items = [];
        const totalPaginas = Math.ceil(filteredEmployees.length / employeesPerPage); // Use filteredEmployees para calcular o total de páginas

        // Primeira página
        if (currentPage > 2) {
            items.push(
                <Pagination.Item
                    key="first"
                    onClick={() => setCurrentPage(1)}
                >
                    1
                </Pagination.Item>
            );
        }

        // Reticências antes da página atual, se necessário
        if (currentPage > 3) {
            items.push(<Pagination.Ellipsis key="startEllipsis" disabled />);
        }

        // Página anterior à atual, se aplicável
        if (currentPage > 1) {
            items.push(
                <Pagination.Item
                    key={currentPage - 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                >
                    {currentPage - 1}
                </Pagination.Item>
            );
        }

        // Página atual
        items.push(
            <Pagination.Item
                key={currentPage}
                active
            >
                {currentPage}
            </Pagination.Item>
        );

        // Página seguinte à atual, se aplicável
        if (currentPage < totalPaginas) {
            items.push(
                <Pagination.Item
                    key={currentPage + 1}
                    onClick={() => setCurrentPage(currentPage + 1)}
                >
                    {currentPage + 1}
                </Pagination.Item>
            );
        }

        // Reticências depois da página atual, se necessário
        if (currentPage < totalPaginas - 2) {
            items.push(<Pagination.Ellipsis key="endEllipsis" disabled />);
        }

        // Última página
        if (currentPage < totalPaginas - 1) {
            items.push(
                <Pagination.Item
                    key="last"
                    onClick={() => setCurrentPage(totalPaginas)}
                >
                    {totalPaginas}
                </Pagination.Item>
            );
        }

        return items;
    };

    const mascaraDocumento = (documento: any) => {
        const limpo = documento.replace(/[\.\-\/\s]/g, '').toUpperCase();

        if (limpo.length <= 11) {
            // CPF
            const cpf = limpo.replace(/\D/g, '');
            return cpf.replace(/(\d{3})(\d)/, '$1.$2')
                      .replace(/(\d{3})(\d)/, '$1.$2')
                      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        } else if (limpo.length === 14) {
            // CNPJ (numérico ou alfanumérico)
            return `${limpo.substring(0,2)}.${limpo.substring(2,5)}.${limpo.substring(5,8)}/${limpo.substring(8,12)}-${limpo.substring(12,14)}`;
        }

        return documento;
    }

    const handleDeleteAccredited = async () => {
        try {
            const response = await api.post(`excluir-credenciado/${idSelected}`);

            if (response.status == 200) {
                setShow(false);
                setAlert({ show: true, message: 'Credenciado excluído com sucesso!', variant: 'success' });
                loadAccredited();
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='./' />
            <Main>
                <CardContent>
                    <Row className='my-4'>
                        <Title text="Credenciados" />
                        <Col md={8} className='newbutton'>
                            <Button className='btn-main' href={`credenciados/cadastrar`}><FillPlus /> Novo Credenciado</Button>
                        </Col>
                        <Col md={4}>
                            <Search placeHolder="Procure pelo nome" onChange={handleSearchChange} />
                        </Col>
                    </Row>
                    <Row className='mb-4'>
                        <Col sm={10} className='my-2 d-flex align-items-end'>
                            <span>Página {currentPage} de {Math.ceil(accredited.length / employeesPerPage)}</span>
                        </Col>
                        <Col sm={2} className='my-2 d-flex justify-content-end'>
                            <Select id='employeesPerPageSelect' onSelect={handleEmployeesPerPageChange}>
                                {employeesPerPageOptions.map((option) => (
                                    <Options
                                        key={option}
                                        value={option}
                                        name={`${option} por página`}
                                        selected={option === employeesPerPage}
                                    />
                                ))}
                            </Select>

                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div style={{ border: '1px solid #007bff', borderRadius: '6px', overflow: 'hidden', marginTop: '30px' }}>
                                <div style={{ overflow: 'auto' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr className="table-row-funcao" style={{ backgroundColor: '#007bff', color: 'white', textAlign: 'center' }}>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Nome</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Documento</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Chave Pix</th>
                                                <th style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {accredited.map((acc: any, index) => (
                                                <tr className="table-row-funcao" key={index} style={{ textAlign: 'center' }}>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                        {acc.nome}
                                                    </td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                        {mascaraDocumento(acc.documento)}
                                                    </td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                        {acc.chave_pix}
                                                    </td>
                                                    <td style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal', borderTop: '1px solid lightgray' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                                            <a href={`credenciados/editar/${acc.id}`} style={{ textDecoration: 'none', color: '#007bff', border: '1px solid #007bff', padding: '5px 10px', borderRadius: '4px', display: 'inline-block' }}>
                                                                Editar
                                                            </a>
                                                            <button
                                                                onClick={() => showModal(acc.id)}
                                                                style={{ marginLeft: '10px', backgroundColor: 'transparent', border: '1px solid red', color: 'red', padding: '5px 10px', borderRadius: '4px', display: 'inline-block' }}>
                                                                Excluir
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col className='d-flex justify-content-center mt-4'>
                            <div className="pagination">
                                <Pagination>
                                    {paginationItems()}
                                </Pagination>
                            </div>
                        </Col>
                    </Row>
                </CardContent>
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmação de exclusão</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Você tem certeza que deseja excluir este item?</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancelar
                        </Button>
                        <Button variant="primary" onClick={handleDeleteAccredited}>
                            Confirmar
                        </Button>
                    </Modal.Footer>
                </Modal>
                <AlertMessage
                    show={alert.show}
                    message={alert.message}
                    variant={alert.variant}
                    onClose={() => setAlert({ ...alert, show: false })}
                />
            </Main>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div >
    );
}